import { useEffect } from 'react';
import UserSearch from '../components/users/UserSearch';
import Footer from '../components/footers/Footer';
import ApplicationBar from '../components/shared/ApplicationBar';
import logo from '../logo.png';

const Users = () => {
    useEffect(() => {
        document.title = 'FestiShare Support - Users';
    }, []);

    return (
        <div>
            <div className="w-full flex justify-center">
                <img className="flex justify-center shadow rounded-xl" src={logo} alt="Logo" width={63} />
            </div>
            <UserSearch />
            <Footer />
            <ApplicationBar />
        </div>
    );
};

export default Users;
